import { defineMessages, IntlFormatters } from "react-intl";
import { RhythmSyllableType, SolfaAudioType } from "../../front/store/user/models";

const rhytnameOptionsMessages = defineMessages({
    ririTamTi: {
        id: "rhytnameOptions.ririTamTi",
    },
    tiriTamTi: {
        id: "rhytnameOptions.tiriTamTi",
    },
    teteTamTi: {
        id: "rhytnameOptions.teteTamTi",
    },
    tiriTaiTi: {
        id: "rhytnameOptions.tiriTaiTi",
    },
    taKaDiMi: {
        id: "rhytnameOptions.taKaDiMi",
    },
    gordon: {
        id: "rhytnameOptions.gordon",
    },
    taKaTiKi: {
        id: "rhytnameOptions.taKaTiKi",
    },
    french: {
        id: "rhytnameOptions.french",
    },
    aussie: {
        id: "rhytnameOptions.aussie",
    }
});

export const rhytnameOptions = (fm: IntlFormatters["formatMessage"]) => [
    {
        label: fm(rhytnameOptionsMessages.ririTamTi),
        value: RhythmSyllableType.Kodaly,
    },
    {
        label: fm(rhytnameOptionsMessages.tiriTamTi),
        value: RhythmSyllableType.KodalyTiRi,
    },
    {
        label: fm(rhytnameOptionsMessages.tiriTaiTi),
        value: RhythmSyllableType.KodalyTiRiTaiTi,
    },
    {
        label: fm(rhytnameOptionsMessages.teteTamTi),
        value: RhythmSyllableType.KodalyTeTe,
    },
    {
        label: fm(rhytnameOptionsMessages.aussie),
        value: RhythmSyllableType.Aussie,
    },
    {
        label: fm(rhytnameOptionsMessages.taKaDiMi),
        value: RhythmSyllableType.Takadimi,
    },
    {
        label: fm(rhytnameOptionsMessages.gordon),
        value: RhythmSyllableType.Gordon,
    },
    {
        label: fm(rhytnameOptionsMessages.taKaTiKi),
        value: RhythmSyllableType.Takatiki,
    },
    {
        label: fm(rhytnameOptionsMessages.french),
        value: RhythmSyllableType.French,
    },
];

const solfaAudioOptionsMessages = defineMessages({
    solfa: {
        id: "solfaAudio.solfa",
    },
    lala: {
        id: "solfaAudio.lala",
    },
    piano: {
        id: "solfaAudio.piano",
    },
})

export const solfaAudioOptions = (fm: IntlFormatters["formatMessage"]) => [
    {
        label: fm(solfaAudioOptionsMessages.solfa),
        value: SolfaAudioType.Solfa,
    },
    {
        label: fm(solfaAudioOptionsMessages.lala),
        value: SolfaAudioType.Lala,
    },
    {
        label: fm(solfaAudioOptionsMessages.piano),
        value: SolfaAudioType.Piano,
    },
]

const rhytPlayStyleOptionsMessages = defineMessages({
    auto: {
        id: "rhytPlayStyleOptions.auto",
    },
    slap: {
        id: "rhytPlayStyleOptions.slap",
    },
    piano: {
        id: "rhytPlayStyleOptions.piano",
    },
});

export const rhytPlayStyleOptions = (fm: IntlFormatters["formatMessage"]) => [
    {
        label: fm(rhytPlayStyleOptionsMessages.auto),
        value: "auto",
    },
    {
        label: fm(rhytPlayStyleOptionsMessages.slap),
        value: "slap",
    },
    {
        label: fm(rhytPlayStyleOptionsMessages.piano),
        value: "piano",
    },
];


const rhytPatternMessages = defineMessages({
    ta_ta: {
        id: "rhytPatterns.ta_ta",
    },
    titi: {
        id: "rhytPatterns.titi",
    },
    tam_ti: {
        id: "rhytPatterns.tam_ti",
    },
    ti_tam: {
        id: "rhytPatterns.ti_tam",
    },
    "ta-a": {
        id: "rhytPatterns.ta-a",
    },
    "ta-a-a": {
        id: "rhytPatterns.ta-a-a",
    },
    "ta-a-a-a": {
        id: "rhytPatterns.ta-a-a-a",
    },
    synkope: {
        id: "rhytPatterns.synkope",
    },
    timri: {
        id: "rhytPatterns.timri",
    },
    ritim: {
        id: "rhytPatterns.ritim",
    },
    tiriri: {
        id: "rhytPatterns.tiriri",
    },
    ririti: {
        id: "rhytPatterns.ririti",
    },
    riririri: {
        id: "rhytPatterns.riririri",
    },
    rest4: {
        id: "rhytPatterns.rest-4",
    },
    rest8: {
        id: "rhytPatterns.rest-8",
    },
    rest16: {
        id: "rhytPatterns.rest-16",
    },
    truplet: {
        id: "rhytPatterns.truplet",
    },
    tie: {
        id: "rhytPatterns.tie",
    },
});

export const rhytPatterns = (fm: IntlFormatters["formatMessage"]): {[prop: string]: string} => ({
    "ta ta": fm(rhytPatternMessages.ta_ta),
    titi: fm(rhytPatternMessages.titi),
    "tam ti": fm(rhytPatternMessages.tam_ti),
    "ti tam": fm(rhytPatternMessages.ti_tam),
    "ta-a": fm(rhytPatternMessages["ta-a"]),
    "ta-a-a": fm(rhytPatternMessages["ta-a-a"]),
    "ta-a-a-a": fm(rhytPatternMessages["ta-a-a-a"]),
    synkope: fm(rhytPatternMessages.synkope),
    timri: fm(rhytPatternMessages.timri),
    ritim: fm(rhytPatternMessages.ritim),
    tiriri: fm(rhytPatternMessages.tiriri),
    ririti: fm(rhytPatternMessages.ririti),
    riririri: fm(rhytPatternMessages.riririri),
    "rest-4": fm(rhytPatternMessages.rest4),
    "rest-8": fm(rhytPatternMessages.rest8),
    "rest-16": fm(rhytPatternMessages.rest16),
    truplet: fm(rhytPatternMessages.truplet),
    tie: fm(rhytPatternMessages.tie),
});
